import { BRANDS_REGION_LIST } from "@/app/(protected)/concepting/components/StepOne/constants";

export const LIFESTYLE_BRIEF_SHEET_NAME = "Brief Example ";
export const COPY_BRIEF_SHEET_NAME = "Product Intake";

export const brandMarketValidationMap: Record<string, string[]> = {
  isColumnsValidationOptional: [BRANDS_REGION_LIST.OREO_BRAZIL],
};

export const COLUMN_VALUES = {
  GTIN: "GTIN",
  ALL_GTIN: "ALL GTINs",
  IMAGE_DELIVERABLES: "Image Deliverables",
  IMAGE_NOTES: "Image Notes/Comments",
  PRODUCT_TYPE: "Product Type",
  REFRESH: "Refresh (Y/N)",
  PROGRAM_RATIONALE: "Program Rationale (Consumer Facing)",
  PRODUCT_NAME_QTY: "Product Name and Quantity",
  FLAVOR_TEXTURE: "Flavor / Texture Descriptor",
  CLAIMS: "Claims",
  USAGE_OCCASION: "Usage Occasion",
  PACKAGING_FEATURE: "Packaging Feature (go-cup, resealable bag, etc.)",
  NEW_REPEAT: "New/Repeat",
  PRODUCT_DESCRIPTION: "Product Description",
} as const;
